const divs = document.querySelectorAll('.master_gallery .gallery-container div');
const master_gallery = document.querySelector('.master_gallery');
const prev = document.querySelector('.master_gallery .prev');
const next = document.querySelector('.master_gallery .next');

checkPrev = () => document.querySelector('.master_gallery .gallery-container div:first-child').classList.contains('show') ? prev.style.display = 'none' : prev.style.display = 'flex';

checkNext = () => document.querySelector('.master_gallery .gallery-container div:last-child').classList.contains('show') ? next.style.display = 'none' : next.style.display = 'flex';
			
Array.prototype.slice.call(divs).forEach(function (el) {
			el.addEventListener('click', function () {
             
				this.classList.toggle('show');
				master_gallery.classList.toggle('active');
              
              	
              
              	if(!this.classList.contains('show')){
              		document.querySelector('.master_gallery .prev').style.display = "none";
                  	document.querySelector('.master_gallery .next').style.display = "none";
                }else{
					//document.querySelector('.master_gallery .prev').style.display = "flex";
                  	//document.querySelector('.master_gallery .next').style.display = "flex";  
                  	checkNext();
					checkPrev();
                }
              
				//checkNext();
				//checkPrev();
			});
});

prev.addEventListener('click', function() {
			const show = document.querySelector('.show');
			const event = document.createEvent('HTMLEvents');
			event.initEvent('click', true, false);

			show.previousElementSibling.dispatchEvent(event);
			show.classList.remove('show');
			master_gallery.classList.toggle('active');
  
            
			checkNext();
});

next.addEventListener('click', function() {
			const show = document.querySelector('.show');
			const event = document.createEvent('HTMLEvents');
			event.initEvent('click', true, false);

			show.nextElementSibling.dispatchEvent(event);
			show.classList.remove('show');
			master_gallery.classList.toggle('active');
			checkPrev();
});